import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';

// ----------------------------------------------------------------------

export default function AccessGuard({ children, requiredAccess = [] }) {
    const router = useRouter();
    const { user } = useMockedUser();
  
    const [checked, setChecked] = useState(false);
  
    const requiredAccessKey = requiredAccess.join(',');

    useEffect(() => {
      if (!user) return;

      if (!user.accesstoken) {
        router.replace('/login');
        return;
      }

      if (!requiredAccessKey) {
        setChecked(true);
        return;
      }

      const userAccess = (user.user_type === 'technician' && user?.contractor)
        ? (user?.contractor?.platform_access || ['support_center'])
        : (user?.platform_access || ['support_center']);

      const hasAccess = requiredAccessKey.split(',').some((access) => userAccess.includes(access));

      if (!hasAccess) {
        router.replace(paths.page403);
        return;
      }

      setChecked(true);
    }, [user, requiredAccessKey, router]);
  
    if (!checked) return null; // shows nothing while waiting
  
    return <>{children}</>;
  }

AccessGuard.propTypes = {
  children: PropTypes.node,
  requiredAccess: PropTypes.arrayOf(PropTypes.string),
};